// Responsive card count for the subscription upsell block (excluding the promo slot).
// xs = mobile (2), sm/md = tablet (3), lg+ = desktop.
const CARDS_BY_BREAKPOINT = {
  xs: 2,
  sm: 3,
  md: 3,
  lg: 3,
  xl: 4,
  xxl: 5,
}

export function getCardCount(breakpoint) {
  return CARDS_BY_BREAKPOINT[breakpoint] ?? 0
}
